import { render, staticRenderFns } from "./title-btn-search.vue?vue&type=template&id=2ae5549c&scoped=true"
import script from "./title-btn-search.vue?vue&type=script&lang=js"
export * from "./title-btn-search.vue?vue&type=script&lang=js"
import style0 from "./title-btn-search.vue?vue&type=style&index=0&id=2ae5549c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae5549c",
  null
  
)

export default component.exports